 import { styled } from "@mui/material/styles";

 const StyledUserProfile = styled("div")(
  ({ theme }) => `
  .user-profile-container {
    width: 100%;
    margin: 0px auto;
    text-align: center;
  }
  .user-profile-header-section {
    position: relative;
    background-color: ${theme.palette.customColor.secondaryFirst};
    width: 100%;
    height: 200px;
  }
  .user-profile-body-section-wrap {
    position: relative;
    background-color: ${theme.palette.customColor.white};
    margin: 0px 30%;
    @media screen and (max-width: 600px) {
    margin: 0px 5%;
  }
  }  
  .user-profile-body-section {
    position: relative;
  }  
  .user-profile-heading {
    font-family: Lexend;
    color: ${theme.palette.primary.main};
    font-weight: 400;
    font-size: 32px;
    line-height: 100%;
    position: absolute;
    top: -20%;
    text-align: left;
  }
  .user-profile-user-info {
    position: relative;
    top: -30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }  
  .user-profile-img {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border: 1px solid ${theme.palette.customColor.secondaryThird};
    margin: 0 auto;
    position: relative;
    object-fit: contain;
  }
  .user-profile-name {
    font-family: Lexend;
    color: ${theme.palette.primary.main};
    font-weight: 500;
    font-size: 18px;
    line-height: 100%;
  }
  .user-profile-email {
    font-family: Lexend;
    color: ${theme.palette.customColor.secondarySecond};
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    margin-top: 10px;
  }
  .user-profile-tags {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 10px;
    align-items: center;
  }
  .user-profile-tag {
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    padding: 3px 10px;
    height: 20px;
    border-radius: 20px;
    background-color: rgba(167, 141, 120, 0.1);
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    color: #7D634F;
  }
  .user-profile-btn-section {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
  .user-profile-btn-container {
    border: 1px solid ${theme.palette.customColor.secondaryThird};
    padding: 20px 15px;
    display: flex;
    gap: 10px;
    align-items: flex-start;
    width: 95%;
    cursor: pointer;
  }
  .user-profile-btn-body {
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .user-profile-btn-text-heading {
    font-family: Lexend;
    color: ${theme.palette.primary.secondary};
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
  }
  .user-profile-btn-text {
    font-family: Lexend;
    color: ${theme.palette.customColor.secondarySecond};
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
  }
  .user-profile-footer-section {
    display: flex;
    justify-content: center;
    margin: 50px 0px;
  }
  .user-profile-logout-btn {
    border: 1px solid ${theme.palette.primary.main};
    color: ${theme.palette.primary.main};
    text-transform: none;
    border-radius: 0px;
    font-family: Lexend;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    width: 100%;
    height: 40px;
  }
  .user-profile-name-container {
    display: flex;
    gap: 5px;
    align-items: center;
    justify-content: center;
  }
  .user-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
  .user-profile-img-loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
  .user-profile-tag-text {
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    color: #7D634F;
  }                                    
    
  `
 );

 export default StyledUserProfile;
